import { formatEmissionUnit } from "@/lib/emissionUnits";

/** Preserve scientific unit case inside uppercase headings and field labels. */
export function EmissionUnitText({ text }: { text: string }) {
  const parts = formatEmissionUnit(text).split(
    /((?:\b(?:kg|g|t|kt|Mt) )?CO₂e(?:\/[^\s()[\],;]+)?)/g,
  );
  return parts.map((part, index) =>
    index % 2 === 0 ? (
      part
    ) : (
      <span
        key={index}
        className="whitespace-nowrap"
        style={{ textTransform: "none" }}
      >
        {part}
      </span>
    ),
  );
}
